import React, { useEffect, useState } from "react";
import { BrowserRouter, Switch, Route as PublicRoute } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Portal } from "@material-ui/core";

import LoggedInLayout from "../layout";
import Dashboard from "../pages/Dashboard";
import TicketResponsiveContainer from "../pages/TicketResponsiveContainer";
import Signup from "../pages/Signup";
import Login from "../pages/Login";
import Connections from "../pages/Connections";
import SettingsCustom from "../pages/SettingsCustom";
import Financeiro from "../pages/Financeiro";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts";
import ContactImportPage from "../pages/Contacts/import";
import Clients from "../pages/Clients";
import ClientCatalogs from "../pages/ClientCatalogs";
import ClientSources from "../pages/ClientSources";
import ClientHardwareAuthorizations from "../pages/ClientHardwareAuthorizations";
import ChatMoments from "../pages/Moments"
import Queues from "../pages/Queues";
import Tags from "../pages/Tags";
import MessagesAPI from "../pages/MessagesAPI";
import Helps from "../pages/Helps";
import ContactLists from "../pages/ContactLists";
import ContactListItems from "../pages/ContactListItems";
import Companies from "../pages/Companies";
import QuickMessages from "../pages/QuickMessages";
import { AuthProvider } from "../context/Auth/AuthContext";
import { TicketsContextProvider } from "../context/Tickets/TicketsContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import { CurrencyProvider } from "../context/Currency/CurrencyContext";
import Route from "./Route";
import Schedules from "../pages/Schedules";
import Campaigns from "../pages/Campaigns";
import CampaignsConfig from "../pages/CampaignsConfig";
import CampaignReport from "../pages/CampaignReport";
import Annoucements from "../pages/Annoucements";
import Chat from "../pages/Chat";
import Prompts from "../pages/Prompts";
import AllConnections from "../pages/AllConnections";
import Reports from "../pages/Reports";
import AdminInsights from "../pages/AdminInsights";
import CoachManagement from "../pages/CoachManagement";
import { FlowBuilderConfig } from "../pages/FlowBuilderConfig";
// import Integrations from '../pages/Integrations';
// import GoogleCalendarComponent from '../pages/Integrations/components/GoogleCalendarComponent';
import FlowBuilder from "../pages/FlowBuilder";
import CampaignsPhrase from "../pages/CampaignsPhrase";
import QueueIntegration from "../pages/QueueIntegration";
// import Files from "../pages/Files"; // REMOVIDO: Lista de arquivos não é mais usado
import ToDoList from "../pages/ToDoList";
import Kanban from "../pages/Kanban";
import TagsKanban from "../pages/TagsKanban";
import ForgotPassword from "../pages/ForgetPassWord";
import GoogleMapsScraper from "../pages/GoogleMapsScraper";
import ResetPassword from "../pages/ResetPassword";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermsOfUse from "../pages/TermsOfUse";
import DataDeletion from "../pages/DataDeletion";
import AiCenter from "../pages/AiCenter";
import ServiceRating from "../pages/ServiceRating";
import InternalNotifications from "../pages/InternalNotifications";
import ServiceRatings from "../pages/ServiceRatings";
import WhatsAppStatuses from "../pages/WhatsAppStatuses";
import FacilwebOpportunities from "../pages/FacilwebOpportunities";
import FacilwebApiAuthorization from "../pages/FacilwebApiAuthorization";


const Routes = () => {
  const [showCampaigns, setShowCampaigns] = useState(false);

  useEffect(() => {
    const cshow = localStorage.getItem("cshow");
    if (cshow !== undefined) {
      setShowCampaigns(true);
    }
  }, []);

  // Rotas 100% publicas - fora de qualquer provider de autenticacao
  const publicPaths = ["/politicas", "/termos", "/exclusao-dados", "/facilweb/autorizar"];
  const pathname = window.location.pathname;
  const isPublicPage = publicPaths.includes(pathname) || pathname.startsWith("/service-rating/");

  if (isPublicPage) {
    return (
      <BrowserRouter>
        <Switch>
          <PublicRoute exact path="/politicas" component={PrivacyPolicy} />
          <PublicRoute exact path="/termos" component={TermsOfUse} />
          <PublicRoute exact path="/exclusao-dados" component={DataDeletion} />
          <PublicRoute exact path="/service-rating/:token" component={ServiceRating} />
          <PublicRoute exact path="/facilweb/autorizar" component={FacilwebApiAuthorization} />
        </Switch>
      </BrowserRouter>
    );
  }

  return (
    <BrowserRouter>
      <AuthProvider>
        <CurrencyProvider>
          <TicketsContextProvider>
          <Switch>
            <Route exact path="/login" component={Login} />
            <Route exact path="/signup" component={Signup} />
            <Route exact path="/forgot-password" component={ForgotPassword} />
            <Route exact path="/reset-password" component={ResetPassword} />
            <WhatsAppsProvider>
              <LoggedInLayout>
                <Route exact path="/financeiro" component={Financeiro} isPrivate />

                <Route exact path="/companies" component={Companies} isPrivate />
                <Route exact path="/" component={Dashboard} isPrivate />
                <Route exact path="/tickets/:ticketId?" component={TicketResponsiveContainer} isPrivate />
                <Route exact path="/connections" component={Connections} isPrivate />
                <Route exact path="/quick-messages" component={QuickMessages} isPrivate />
                <Route exact path="/todolist" component={ToDoList} isPrivate />
                <Route exact path="/schedules" component={Schedules} isPrivate />
                <Route exact path="/tags" component={Tags} isPrivate />
                <Route exact path="/contacts" component={Contacts} isPrivate />
                <Route exact path="/contacts/import" component={ContactImportPage} isPrivate />
                <Route exact path="/clients" component={Clients} isPrivate />
                <Route exact path="/clients/catalogs" component={ClientCatalogs} isPrivate />
                <Route exact path="/clients/sources" component={ClientSources} isPrivate />
                <Route exact path="/clients/hardware-authorizations" component={ClientHardwareAuthorizations} isPrivate />
                <Route exact path="/helps" component={Helps} isPrivate />
                <Route exact path="/users" component={Users} isPrivate />
                <Route exact path="/messages-api" component={MessagesAPI} isPrivate />
                <Route exact path="/settings" component={SettingsCustom} isPrivate />
                <Route exact path="/queues" component={Queues} isPrivate />
                <Route exact path="/reports" component={Reports} isPrivate />
                <Route exact path="/admin-insights" component={AdminInsights} isPrivate />
                <Route exact path="/coach-management" component={CoachManagement} isPrivate />
                <Route exact path="/queue-integration" component={QueueIntegration} isPrivate />
                <Route exact path="/announcements" component={Annoucements} isPrivate />
                <Route exact path="/internal-notifications" component={InternalNotifications} isPrivate />
                <Route exact path="/service-ratings" component={ServiceRatings} isPrivate />
                <Route exact path="/whatsapp-statuses" component={WhatsAppStatuses} isPrivate />
                <Route exact path="/facilweb-opportunities" component={FacilwebOpportunities} isPrivate />
                <Route
                  exact
                  path="/phrase-lists"
                  component={CampaignsPhrase}
                  isPrivate
                />
                <Route
                  exact
                  path="/flowbuilders"
                  component={FlowBuilder}
                  isPrivate
                />
                <Route
                  exact
                  path="/flowbuilder/:id?"
                  component={FlowBuilderConfig}
                  isPrivate
                />
                <Route exact path="/chats/:id?" component={Chat} isPrivate />
                {/* REMOVIDO: Lista de arquivos não é mais usado */}
                {/* <Route exact path="/files" component={Files} isPrivate /> */}
                <Route exact path="/moments" component={ChatMoments} isPrivate />
                <Route exact path="/kanban" component={Kanban} isPrivate />
                <Route exact path="/tagsKanban" component={TagsKanban} isPrivate />
                <Route exact path="/prompts" component={Prompts} isPrivate />
                <Route exact path="/ai-center" component={AiCenter} isPrivate />
                <Route exact path="/allConnections" component={AllConnections} isPrivate />
                <Route exact path="/google-maps-scraper" component={GoogleMapsScraper} isPrivate />
                {showCampaigns && (
                  <>
                    <Route exact path="/contact-lists" component={ContactLists} isPrivate />
                    <Route exact path="/contact-lists/:contactListId/contacts" component={ContactListItems} isPrivate />
                    <Route exact path="/campaigns" component={Campaigns} isPrivate />
                    <Route exact path="/campaign/:campaignId/report" component={CampaignReport} isPrivate />
                    <Route exact path="/campaigns-config" component={CampaignsConfig} isPrivate />
                  </>
                )}
              </LoggedInLayout>
            </WhatsAppsProvider>
          </Switch>
          <Portal>
            <ToastContainer position="top-center" autoClose={3000} style={{ zIndex: 2147483647 }} />
          </Portal>
          </TicketsContextProvider>
        </CurrencyProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
